import firebase from 'firebase/app'
import 'firebase/storage'
import pos from '@/services/local'
import util from "@/util/util";

export default {
  async onUpload(uid, ref, image, ext) {
    let fileTMP = new Date().getTime()

    let directoryPath = 'resources/' + uid + '/resources/products/' + ref
    let refpath = directoryPath + '/' + fileTMP + '.' + ext
    
    try {
      const snapshot = await firebase
        .storage()
        .ref(refpath)
        .putString(image, 'data_url')
      
      return await snapshot.ref.getDownloadURL()
    } catch (e) {
      return e.message
    }
  },
  async onUpload2(directoryPath, image) {
    const refpath = directoryPath
    try {
      const snapshot = await firebase
        .storage()
        .ref(refpath)
        .putString(image, 'data_url')
      return await snapshot.ref.getDownloadURL()
    } catch (e) {
      return e.message
    }
  },

  async deleteImage(uid, shopObjectId, remoteImagePath) {
    const sizes = ['100x100', '200x200', '300x300', '400x400'];
    
    const pathsToDelete = [
      remoteImagePath,
      ...sizes.map(size => remoteImagePath.replace(/\.(png|jpg|jpeg|webp)/, `_${size}.webp`)),
      ...sizes.map(size => remoteImagePath.replace(/\.(png|jpg|jpeg|webp)/, `_${size}.jpeg`)),
      ...sizes.map(size => remoteImagePath.replace('?alt=media', `_${size}?alt=media`))
    ];

    const deleteRemoteImage = async (path) => {
      const data = { remoteImagePath: path };
      try {
        await pos({
          method: 'post',
          url: `/api/v1.0/image/${uid}/${shopObjectId}/deleteremoteimg`,
          data: data,
        });
      } catch (error) {
        console.log(`Error deleting ${path}:`, error);
      }
    };

    for (const path of new Set(pathsToDelete)) {
      await deleteRemoteImage(path);
    }
  },

  async deleteImage2(directoryPath) {
    const refpath = directoryPath
    try {
      return await firebase
        .storage()
        .ref(refpath)
        .delete()
    } catch (e) {
      return e.message
    }
  },
    /**
   * อัปเดตข้อมูลรูปภาพสินค้า (PLU) ไปยัง API หลังบ้านด้วยวิธี PATCH
   *  "mode": "pre-upload",
   */
  async updateProductImage(uid, shopObjectId, pluCode, base64Image,ismodepreupload) {
    const data = {      
      shopObjectId: shopObjectId,
      PLUCode: pluCode,
      base64Image: base64Image,
      ...(ismodepreupload && { mode: "pre-upload" })
    };


    try {
      // ทำการส่งคำขอด้วย pos โดยเก็บผลลัพธ์ไว้ที่ตัวแปร res
      const res = await pos({
        method: 'PATCH',
        url: `/api/v3.0/productplu/image`,
        data: data,
        headers: {
          'shopObjectId': util.sanitizeShopObjectId(shopObjectId)
        }
      });

      // คืนค่าข้อมูลที่ได้จาก API กลับไปให้ savedata() ใช้งานต่อ
      return res.data;
      
    } catch (error) {
      // แก้ไขให้แสดงข้อความ error ของการอัปเดตรูปภาพอย่างถูกต้อง ไม่ให้ตัวแปรพัง
      console.error('Error updating product image via PATCH:', error.message || error);
      throw error; // โยน Error กลับเพื่อให้ฝั่ง savedata เข้าบล็อก catch และแสดงแจ้งเตือนบนหน้าจอ
    }
  },
}
